import React from 'react';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip';
import services from './services';
import adaTheme from '../../theme';

const useStyles = makeStyles(theme => ({
  wrap: {
    position: 'fixed',
    bottom: theme.spacing(2),
    left: '50%',
    zIndex: 1300,
  },
  root: {
    transform: 'translate(-50%,0)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.black,
    borderRadius: 10,
    boxShadow: theme.shadows[5],
  },
  isHidden: {},
}));

const AtomicToolbar = props => {
  const { editorState, services, inlineStyleServices } = props;

  const selection = editorState.getSelection();

  const startKey = editorState.getSelection().getStartKey();
  const selectedBlock = editorState
    .getCurrentContent()
    .getBlockForKey(startKey);

  const inlineStyleIsMutable =
    inlineStyleServices.findIndex(
      s => s.blockType === selectedBlock.getType(),
    ) > -1 || selectedBlock.getType() === 'unstyled';

  const isHidden =
    !selection.isCollapsed() ||
    !selection.getHasFocus() ||
    props.editorPaused ||
    !inlineStyleIsMutable;

  const [OverrideContent, setOverrideContent] = React.useState(null);

  const handleOverrideContent = content => {
    setOverrideContent(content);
  };

  const blockTypeIsMutable =
    services.findIndex(s => s.blockType === selectedBlock.getType()) > -1 ||
    selectedBlock.getType() === 'unstyled';
  const classes = useStyles(props);

  return (
    <MuiThemeProvider theme={adaTheme}>
      <Slide direction="up" in={!isHidden}>
        <div className={classes.wrap}>
          <div className={classes.root}>
            {OverrideContent ? (
              <OverrideContent
                editorState={editorState}
                setEditorState={props.setEditorState}
                onOverrideContent={handleOverrideContent}
              />
            ) : (
              services.map(Service => (
                <Tooltip
                  title={Service.help}
                  placement="top"
                  key={Service.displayName}
                >
                  <Service
                    //isHidden={!blockTypeIsMutable}
                    editorState={editorState}
                    setEditorState={props.setEditorState}
                    onOverrideContent={handleOverrideContent}
                  />
                </Tooltip>
              ))
            )}
          </div>
        </div>
      </Slide>
    </MuiThemeProvider>
  );
};

AtomicToolbar.defaultProps = {
  services,
};

export default AtomicToolbar;
